import React from "react";
import { CircularProgress } from "@material-ui/core";
import CartaoItem from "../../../components/CartaoItem";
import Button from "../../../components/Button";
import styles from "../../../styles/Configuracoes.module.scss";

export default function TabPagamento({ cartoes, loading_cartoes, onAdicionar, onExcluir }) {
  return (
    <>
      <p>
        Os métodos de pagamento cadastrados serão utilizados para as atividades na sua Conta Corporativa da Chof. Você não receberá cobranças até que solicite uma viagem.
      </p>

      {loading_cartoes ? (
        <div className={styles.loadingCartoes}>
          <CircularProgress color="inherit" />
        </div>
      ) : (
        cartoes.length > 0 && (
          <div className={styles.listaCartoes}>
            {cartoes.map((cartao) => (
              <CartaoItem
                key={cartao.id}
                cartao={cartao}
                selecionado={false}
                modo="excluir"
                onExcluir={onExcluir}
              />
            ))}
          </div>
        )
      )}

      <div>
        <Button
          type="button"
          variant="primary"
          outlined
          size="md"
          onClick={onAdicionar}
          fullWidth={false}
        >
          Adicionar cartão &nbsp;+
        </Button>
      </div>
    </>
  );
}
